import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createFeaturedOffer, getDeglawyOffers, getFeaturedOfferId, getFeaturedOffers, updateFeaturedOffersOrder, updateFeatureOffer,
} from '../../axios/featuredOfferRequests';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  IFeaturedOffer, OfferTypes,
} from '../storeInterfaces/featuredOfferInterface';
import { RequestStatus } from 'mobx-store';

export class FeaturedOfferStore {
  @observable selectedFeaturedOffer: IFeaturedOffer = {
    deglawyOfferId: -1,
    featuredOfferId: -1,
    imageURL: ' ',
    title: ' ',
    isHotDeal: false,
    discountPercentage: 0,
  };

  @observable featuredOffersList: any[] = [];

  @observable deglawyOffersList: any[] = [];

  @observable loading = false;

  @observable loadingDeglawyOffers = false;

  @observable getFeaturedOffersRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getFeaturedOfferById(id: number): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getFeaturedOfferId(id));
      const featuredOffer = response.data;
      
      this.selectedFeaturedOffer = {
        deglawyOfferId: featuredOffer.deglawyOfferId,
        description: featuredOffer.description,
        title: featuredOffer.offerTitle,
        featuredOfferId: featuredOffer.featuredOfferId,
        imageURL: featuredOffer.imageURL,
        type: featuredOffer.type,
        isHotDeal: featuredOffer.isHotDeal,
        discountPercentage: featuredOffer.discountPercentage,
      };
    } catch (error) {
      return Promise.reject();
    } finally {
      this.loading = false;
    }
  }

  @action
  public async updateFeaturedOffer(featuredOfferId: number, newOffer: any): Promise<any> {
    try {
      this.loading = true;
      const deglawyOfferId = newOffer.deglawyOfferId;
      const body: IFeaturedOffer = {
        isHotDeal: newOffer.isHotDeal,
        discountPercentage: newOffer.discountPercentage || 0,
      };
      if(deglawyOfferId){
        const deglawyOffer = this.deglawyOffersList.find((deglawyOffer: any) =>  deglawyOffer.offerId == deglawyOfferId);
        body.deglawyOfferId = deglawyOfferId;
        body.type =  deglawyOffer.type;
      }

      await Connections.wadiDeglaAxios.httpPut(updateFeatureOffer(featuredOfferId), body);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    }
  }

  @action
  public async swapTwoOfferOrder(offerOneIndex: number, offerTwoIndex: number): Promise<any> {
    try {
      this.loading = true;
      const firstFeaturedOfferId = this.featuredOffersList[offerOneIndex].featuredOfferId;
      const secondFeaturedOfferId = this.featuredOffersList[offerTwoIndex].featuredOfferId;
      const params = {
        featuredOfferIdFirst: firstFeaturedOfferId,
        featuredOfferIdSecond: secondFeaturedOfferId,
      };
      await Connections.wadiDeglaAxios.httpPut(updateFeaturedOffersOrder, params);
      await this.getFeaturedOffers();
    } catch (error) {
      return Promise.reject();
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getFeaturedOffers(): Promise<any> {
    try {
      this.loading = true;
      this.getFeaturedOffersRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getFeaturedOffers);
      this.featuredOffersList = this.restructureFeaturedOfferList(response.data);
      this.getFeaturedOffersRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFeaturedOffersRequestStatus = RequestStatus.FAILED;
      return Promise.reject();
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createFeaturedOffer(newFeaturedOffer: any): Promise<any> {
    try {
      const deglawyOfferId = newFeaturedOffer.deglawyOfferId;
      const deglawyOffer = this.deglawyOffersList.find((deglawyOffer: any) =>  deglawyOffer.offerId == deglawyOfferId);
      const body: IFeaturedOffer = {
        deglawyOfferId,
        type: deglawyOffer.type,
        isHotDeal: newFeaturedOffer.isHotDeal,
        discountPercentage: newFeaturedOffer.discountPercentage || 0,
      };
      await Connections.wadiDeglaAxios.httpPost(createFeaturedOffer, body);
    } catch (error) {
      return Promise.reject();
    }
  }

  @action.bound
  public async getDeglawyOffers(): Promise<any> {
    try {
      this.loadingDeglawyOffers = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getDeglawyOffers, getHeader(DefaultLanguage));
      this.deglawyOffersList = this.mapOffersData(response.data);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    } finally {
      this.loadingDeglawyOffers = false;
    }
  }

  private restructureFeaturedOfferList(featuredOfferList: any[]): any[] {
    const featuredOffers: IFeaturedOffer[] = [];
    for (const featuredOffer of featuredOfferList) {
      featuredOffers.push({
        imageURL: featuredOffer.imageURL,
        title: featuredOffer.offerTitle,
        description: featuredOffer.description,
        deglawyOfferId: featuredOffer.deglawyOfferId,
        featuredOfferId: featuredOffer.featuredOfferId,
        type: featuredOffer.type || OfferTypes.DSQUARES,
        isHotDeal: featuredOffer.isHotDeal,
        discountPercentage: featuredOffer.discountPercentage,
      });
    }
    return featuredOffers;
  }



  private mapOffersData(response: any) {
    const deglawyList: any[] = [];
    for (const deglawyItem of response) {
      const item = {
        offerId: deglawyItem.offerId,
        title: `${deglawyItem.partner.name}, ${deglawyItem.title}`,
        type: deglawyItem.type
      };
      deglawyList.push(item);
    }
    return deglawyList;
  }

}
